export default "__VITE_ASSET__d8X7QCvL__"